<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'施設情報'"
      :sub_title="'〜 Facility Info 〜'"
      :color="'#3b3b3b'"
      :align="'center'"
    ></main-title>

    <div :id="$style.button_area">
      <b-button
        :class="$style.button"
        pill
        variant="info"
        v-for="item in items"
        @click="tabClick(item)"
        :key="item.id"
        >{{ item }}</b-button
      >
    </div>

    <!-- 来館について -->
    <article v-show="tab_flag == 0">
      <open-hour-visual :class="$style.open_houre" id="open_hour_area"></open-hour-visual>
      <fee-visual :class="$style.fee" id="fee_area"></fee-visual>
      <access-visual :class="$style.access" id="access_area"></access-visual>
      <bus-schedule-visual
        :class="$style.bus_schedule"
        id="bus_schedule"
      ></bus-schedule-visual>
    </article>

    <!-- 入館上の注意 -->
    <article v-show="tab_flag == 1">
      <!-- <covid-guideline-visual :class="$style.covid_guideline"></covid-guideline-visual> -->
      <attention-visual :class="$style.attention"></attention-visual>
    </article>

    <!--展示品紹介-->
    <article v-show="tab_flag == 2">
      <exhibit-visual :class="$style.exhibit"></exhibit-visual>
    </article>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import OpenHourVisual from "@/components/organsms/facility_info/OpenHourVisual.vue";
import FeeVisual from "@/components/organsms/facility_info/FeeVisual.vue";
import AccessVisual from "@/components/organsms/facility_info/AccessVisual.vue";
import AttentionVisual from "@/components/organsms/facility_info/AttentionVisual.vue";
import BusScheduleVisual from "@/components/organsms/facility_info/BusScheduleVisual.vue";
// import CovidGuidelineVisual from "@/components/organsms/facility_info/CovidGuidelineVisual.vue";
import ExhibitVisual from "@/components/organsms/facility_info/ExhibitVisual.vue";
import VueScrollTo from "vue-scrollto";

export default Vue.extend({
  name: "Info",

  components: {
    MainTitle,
    OpenHourVisual,
    FeeVisual,
    BusScheduleVisual,
    AccessVisual,
    AttentionVisual,
    // CovidGuidelineVisual,
    ExhibitVisual,
  },

  data() {
    return {
      items: ["来館について", "入館上の注意", "施設案内"],
      tab_flag: 0,
    };
  },
  mounted() {
    const hash = this.$route.hash;
    if (hash && hash.match(/^#.+$/)) {
      VueScrollTo.scrollTo(hash, { offset: -90 });
    }
  },
  methods: {
    tabClick(item) {
      if (item == this.items[0]) {
        this.tab_flag = 0;
      } else if (item == this.items[1]) {
        this.tab_flag = 1;
      } else {
        this.tab_flag = 2;
      }
    },
  },
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #f3f8f6ff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    #button_area {
      margin-top: 40px;
      .button {
        width: 90px;
        margin: 0px 10px;
      }
    }
    article {
      display: grid;
      grid-template-columns: 1fr 90% 1fr;
      section {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 30px 20px;
        font-size: 13px;
        max-width: 700px;
        overflow: hidden;
      }
      .access {
        grid-column: 2;
        grid-row: 3;
      }
      .bus_schedule {
        grid-column: 2;
        grid-row: 4;
      }
      .open_houre {
        grid-column: 2;
        grid-row: 1;
      }
      .fee {
        grid-column: 2;
        grid-row: 2;
      }
      .attention {
        grid-column: 2;
        grid-row: 2;
      }
      .covid_guideline {
        grid-column: 2;
        grid-row: 1;
      }
      .exhibit {
        grid-column: 2;
        grid-row: 1;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #f3f8f6ff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;

    .main_title {
      text-align: center;
    }

    #button_area {
      /*margin-right: 500px;*/
      margin-top: 40px;
      .button {
        width: 130px;
        margin: 0px 10px;
      }
    }
    article {
      display: grid;
      grid-template-columns: 1fr 900px 1fr;
      section {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 30px 80px;
      }
      .access {
        grid-column: 2;
        grid-row: 3;
      }
      .bus_schedule {
        grid-column: 2;
        grid-row: 4;
      }
      .open_houre {
        grid-column: 2;
        grid-row: 1;
      }
      .fee {
        grid-column: 2;
        grid-row: 2;
      }
      .attention {
        grid-column: 2;
        grid-row: 2;
      }
      .covid_guideline {
        grid-column: 2;
        grid-row: 1;
      }
      .exhibit {
        grid-column: 2;
        grid-row: 1;
      }
    }
  }
}
</style>
